import forTemplateType from "./templateType/forTemplateType";
import forDataTemplate from "./templateType/forDataTemplate";
import forPresentationTemplate from "./templateType/forPresentationTemplate";
import forTemplateSystem from "./templateSystem/forTemplateSystem";
import forTBuilderModel from "./templateType/forTBuilderModel";

const typeGuards = {
  forTemplateType,
  forDataTemplate,
  forTBuilderModel,
  forPresentationTemplate,
  forTemplateSystem,
};

export default typeGuards;
